import { PayoutOrderListItem } from '@/models/payout-order/payout-order-list.model';
import { useAdminStore } from '@/store/admin/admin.store';
import { usePayoutOrderListStore } from '@/store/payout-order/payout-order-list.store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

// TODO: Change the current realization than the backend is enabled to support multibrand functionality
export const useAdminTakenPayoutOrderCount = () => {
  const { adminEmail } = storeToRefs(useAdminStore());

  const { payoutOrderList } = storeToRefs(usePayoutOrderListStore());

  const adminTakenPayoutOrderCount = computed<number>(() => {
    if (!adminEmail.value) {
      return 0;
    }

    return payoutOrderList.value.filter(
      (payoutOrder: PayoutOrderListItem) => payoutOrder.moderateBackOfficeAdminEmail === adminEmail.value,
    ).length;
  });

  return {
    adminTakenPayoutOrderCount,
  };
};
